import { render, staticRenderFns } from "./NinjaFooter.vue?vue&type=template&id=2ab3d0dd&scoped=true&"
import script from "./NinjaFooter.vue?vue&type=script&lang=js&"
export * from "./NinjaFooter.vue?vue&type=script&lang=js&"
import style0 from "./NinjaFooter.vue?vue&type=style&index=0&id=2ab3d0dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab3d0dd",
  null
  
)

export default component.exports